<template>
  <div v-if="!expired ">
    <img class="spinner_loading" src="../images/ordine/spinner_loading.gif" />
    <p>{{message}}</p>
  </div>
</template>

<script>
export default {
  name: "loaderSpinner",
  props: ["state"],

  data() {
    return {
      expired: false,
      message: "Caricando..."
      //VARIABILI AMBIENTE
    };
  },
  computed: {},
  methods: {},
  mounted() {
    var self = this;
    setTimeout(function() {
      self.message = "Problemi caricamento.Riprova.";
      setTimeout(function() {
        self.expired = true;
      }, 5000);
    }, 5000);
  },
  watch: {}
};
</script>

<style scoped>
div {
  text-align: center;
}
img {
  width: 50px;
  height: 50px;
}
</style>
